import React, {useState} from "react";
import {useDispatch} from "react-redux";
import Button from "../../Common/Button";
import {closeDialog} from "../../../slices/dialog";
import {Cookies} from "react-cookie-consent";
import {makeStyles, MobileStepper} from "@material-ui/core";
import {useTranslation} from "react-i18next";

export const CompanyRmTutorial = () => {
    const dispatch = useDispatch();
    const [activeStep, setActiveStep] = useState(0);
    const maxSteps = 2;
    const {t} = useTranslation();

    const next = () => {
        // if last step close dialog and save tutorial as done, else go on
        if (activeStep === maxSteps - 1) {
            // save that this tutorial was done
            Cookies.set("rmTutorialDone", true, {expires: 1000});

            // close dialog
            dispatch(closeDialog());
            return;
        } else {
            setActiveStep(activeStep + 1);
        }
    };

    const back = () => {
        setActiveStep(activeStep - 1);
    };

    const useStyles = makeStyles({
        root: {
            flexGrow: 1,
        },
    });

    const classes = useStyles();

    return (
        <div className="companyWelcome">
            {activeStep === 0 && (
                <>
                    <h2 className="header mb10">{t("company_tutorial_rm1_title")}</h2>
                    <p className="default mb20">
                        {t("company_tutorial_rm1_text")}
                    </p>
                </>
            )}
            {activeStep === 1 && (
                <>
                    <h2 className="header mb10">
                        {t("company_tutorial_rm2_title")}
                    </h2>
                    <p className="default mb20">
                        {t("company_tutorial_rm2_text")}
                    </p>
                </>
            )}

            <MobileStepper
                variant="dots"
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                className={classes.root}
                nextButton={<Button onClick={next}>{t("company_tutorial_rm_nextBtn")}</Button>}
                backButton={
                    <Button onClick={back} disabled={activeStep === 0}>
                        {t("company_tutorial_rm_backBtn")}
                    </Button>
                }
            />
        </div>
    );
};
